// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"article-tag-filter_wrapper__cDLf0","tag":"article-tag-filter_tag__g2_ut"};